<template>
    <v-layout column class="pa-4" style="height: 100%">
        <div style="background: #fff;height: 100%" class="pa-4">
            <v-layout align-center row wrap class="pb-4">
                <div class="centerY mr-3">
                    <img :src="application.icon" alt="icon" class="mr-3">
                    <p class="text-xs-left display-1 ma-0 mr-3" style="color: #707070">{{application.name}}</p>
                </div>
                <div class="my-3 mr-3">
                    <v-btn color="primary" class="ma-0" @click="goApplication">{{$t('start')}}</v-btn>
                </div>
            </v-layout>
            <v-tabs v-model="activeTab" color="rgba(0,0,0,0)" slider-color="#01AFC8">
                <!--overview-->
                <v-tab ripple>{{$t('overview')}}</v-tab>
                <v-tab-item key="overview">
                    <iframe :src="getOverviewLink()"></iframe>
                </v-tab-item>
            </v-tabs>
        </div>
    </v-layout>
</template>
<script>
/* eslint-disable */
import ChatbotOverviewEn from 'raw-loader!./ChatbotOverview.html'
import ChatbotOverviewVi from 'raw-loader!./ChatbotOverviewVi.html'
/* eslint-enable */
export default {
    name: 'ApplicationDetails',
    data () {
        return {
            activeTab: 0,
            application: null,
            appList: {
                '/application/chatbot': {
                    name: 'Chat Bot',
                    icon: '/static/img/Chatbot.jpg',
                    path: '/application/chatbot',
                    link: 'https://bot.fpt.ai',
                    enable: true,
                    description: 'Build your AI-powered conversation',
                    description_vi: 'Nền tảng tạo lập chatbot ứng dụng trí tuệ nhân tạo',
                    doc_vi: 'https://docs.fpt.ai/docs/vi/conversation/documentation/introduction.html?mode=emb',
                    doc_en: 'https://docs.fpt.ai/docs/en/conversation/documentation/introduction.html?mode=emb'
                },
                '/application/reader': {
                    name: 'Reader',
                    icon: 'https://cdn-static-v3.fpt.ai/livesupport-upload-file/44b361485b4b87efb3c0c8b8a9840f05/fe01cbce98f8ac42332befcf79e791ff.png',
                    enable: true,
                    link: 'https://reader.fpt.ai',
                    path: '/application/reader',
                    description: 'Build your own AI-Powered reader application',
                    description_vi: 'Xây dựng ứng dụng Nhận dạng & Trích xuất nội dung từ ảnh chụp văn bản',
                    doc_vi: 'https://docs.fpt.ai/docs/vi/vision/documentation/reader-introduction/',
                    doc_en: 'https://docs.fpt.ai/docs/en/vision/documentation/reader-introduction/'
                },
                '/application/voicemaker': {
                    name: 'Voice Maker',
                    icon: 'https://cdn-static-v3.fpt.ai/livesupport-upload-file/e52a8754781959aa4168c2cf8db00c54/e0172e39307b53c02f661bb9b174c043.png',
                    enable: true,
                    link: 'https://voicemaker.fpt.ai',
                    path: '/application/voicemaker',
                    description: 'Convert text to speech easily with user-friendly interface',
                    description_vi: 'Ứng dụng chuyển đổi văn bản thành giọng nói với giao diện thân thiện',
                    doc_vi: 'https://docs.fpt.ai/docs/vi/speech/documentation/voice-maker/',
                    doc_en: 'https://docs.fpt.ai/docs/en/speech/documentation/voice-maker/'
                }

            }
        }
    },
    watch: {
    $route() {
      let path = this.$route.path
        console.log("path: ", path);

        this.application = this.appList[path]
        console.log("path: ", this.application);
        this.$store.dispatch(this.$actionTypes.LOADING, false)
    }
  },
    mounted (){
        console.log("route: ", this.$route);
        let path = this.$route.path
        console.log("path: ", path);

        this.application = this.appList[path]
        console.log("path: ", this.application);
        this.$store.dispatch(this.$actionTypes.LOADING, false)
    },
    methods: {
        getOverview () {
            let locale = this.$appService.getLocale()
            return locale === 'en' ? ChatbotOverviewEn : ChatbotOverviewVi
        },
        getOverviewLink () {
            let locale = this.$appService.getLocale()
            return locale === 'en'
                ? this.application.doc_en
                : this.application.doc_vi
        },
        goApplication () {
            window.open(this.application.link, '_blank').focus();
        }
    }
}
</script>
<style scoped>
    /deep/ .v-tabs__bar {
        position: relative;
    }

    /deep/ .v-tabs__bar:after {
        position: absolute;
        width: 100%;
        height: 2px;
        background: #01AFC8;
        content: "";
        bottom: 0;
    }

    /deep/ .v-tabs__item--active {
        background: #01AFC8;
        color: #fff;
    }

    .api-description /deep/ table td,
    .api-description /deep/ table th {
        padding: 5px;
    }

    iframe {
        width: 100%;
        height: calc(100vh - 369px);
        border: none;
    }
</style>
